export default "__VITE_ASSET__CNYREuCP__"